import { defineAction } from '../utils/defineAction';

const INIT = 'INIT';
const SUCCESS = 'SUCCESS';
const ERROR = 'ERROR';

const httpActions = [INIT, SUCCESS, ERROR];

export const PATIENT_REPLACE = defineAction(
  'PATIENT_REPLACE',
  ['CHANGE_STEP', 'VERIFY_PATIENT_INFO', 'CLEAR'],
);

export const SUBMIT_PATIENT_REPLACE_FORM = defineAction(
  'SUBMIT_PATIENT_REPLACE_FORM',
  httpActions,
);
